import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconSearch,
    iconReports,
    iconReportsDefault,
    iconPreAprobador,
    iconPolizas,
    iconCar,
    iconAddDocs,
    iconParameters,
    iconDigitalSignature,
    iconFinancies,
    iconAffiliate,
    iconDocs,
    iconCertificate,
} from '../defaultValues';

const data = {
    role_68a5cff3f9ba418e8892737ac387d234: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'wompi',
            icon: iconFinancies,
            label: 'Wompi',
            to: '/app/WompiExecutive',
        },
        {
            id: 'pre-aprobador',
            icon: iconPreAprobador,
            label: 'Pre-aprobador',
            to: '/app/pre-aprobador',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'terceros',
                    icon: iconReportsDefault,
                    label: 'Terceros',
                    to: '/app/socialReasons',
                },
                {
                    id: 'banck-accounts',
                    icon: iconReportsDefault,
                    label: 'Cuentas bancarias',
                    to: '/app/bankAccounts',
                },
                {
                    icon: iconAffiliate,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
            ],
        },
        // {
        //     icon: iconDigitalSignature,
        //     label: 'Firma Electrónica ',
        //     to: '/app/procedures/digitalSignature',
        // },
        {
            icon: iconDigitalSignature,
            label: 'Firma Electrónica',
            to: '/app/electronicSignature/ElectronicSignature',
        },
        {
            id: 'operaciones',
            icon: iconPolizas,
            label: 'Operaciones',
            to: '/app/calculator',
            subs: [
                {
                    id: 'consulta',
                    icon: iconPolizas,
                    label: 'Excepciones',
                    to: '/app/credits/ExceptionDocuments',
                },
                {
                    id: 'vehiculos',
                    icon: iconCar,
                    label: 'Vehículos',
                    to: '/app/credits/VehicleDocuments',
                },
                {
                    id: 'documents',
                    icon: iconAddDocs,
                    label: 'Documentos',
                    to: '/app/credits/DisbursementDocuments',
                },
                {
                    id: 'runtPreRegistration',
                    icon: iconAddDocs,
                    label: 'Pre registro RUNT',
                    to: '/app/credits/RuntPreRegistration',
                },
            ],
        },
        {
            id: 'tuberia',
            icon: iconReportsDefault,
            label: 'Calculadora',
            to: '/app/reports/calculatorParams',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'certificados',
                    icon: iconCertificate,
                    label: 'Certificados',
                    to: '/app/reports/peaceAndSafe',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Registrar',
                            to: '/app/reports/peaceAndSafe',
                        },
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Consultar',
                            to: '/app/reports/checkCertificates',
                        },
                    ],
                },
            ],
        },
    ],
};
export default data;
